// Central public Pooja API configuration.
// Change only API_BASE when moving to another client/domain.
export const API_BASE = "https://webcontrol.suvidham.in/api".replace(/\/$/, "");

export const POOJA_PUBLIC_API = {
  catalog: `${API_BASE}/public_pooja_catalog.php`,
  featured: `${API_BASE}/public_featured_vazhipads.php`,
  saveOrder: `${API_BASE}/public_pooja_order_save.php`,
};

// Build URLs for images/files returned by the public Pooja APIs.
export const poojaPublicAssetUrl = (path = "") => {
  const value = String(path || "").trim();

  if (!value) return "";
  if (/^https?:\/\//i.test(value)) return value;

  return `${API_BASE}/${value.replace(/^\/+/, "")}`;
};
